import { useTranslation } from 'react-i18next';
import { selectedRoadSectionsQuery } from '../../../../../core/reference/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import { useEffect, useState } from 'react';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ReferenceModalTypes } from '../../../../../core/legacy/reducers/modals';
import { Input } from '../../../../session/list-sessions/styles';
import editRoadSections from '../../../../../core/reference/commands/EditRoadSections';

const EditRoadSectionWidthModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedRoadSections = useAppSelector(selectedRoadSectionsQuery);
    const checkedRoadSectionsIds = checkedRoadSections.map((s) => s.id);

    const [width, setWidth] = useState<string | number | null>(null);

    useEffect(() => {
        const widths = checkedRoadSections
            .map((rs) => rs.width)
            .filter((n) => n !== undefined)
            .reduce((acc, val) => acc.add(val!), new Set<number>());
        if (widths.size === 1) {
            setWidth(widths.values().next().value as number);
        } else {
            setWidth(null);
        }
    }, [checkedRoadSections]);

    const onValidate = () => {
        const parsedValue = typeof width === 'string' ? Number(width.replace(',', '.')) : Number(width);
        dispatch(
            editRoadSections({
                roadSectionData: {
                    width: Number.isNaN(parsedValue) ? null : parsedValue,
                },
                roadSectionIds: checkedRoadSectionsIds,
            }),
        );
        setWidth(null);
    };

    const handleKeyDown = ({ key }: KeyboardEvent) => {
        if (key === 'Enter') {
            onValidate();
        }
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ReferenceModalTypes.ROAD_SECTION_EDIT_WIDTH}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('reference.modals.editWidth')}</ModalTitle>
                <Input
                    onKeyDown={handleKeyDown}
                    value={width}
                    type="text"
                    onChange={(e) => {
                        setWidth(e.target.value);
                    }}
                    autoFocus
                />
            </ContentContainer>
        </GenericModal>
    );
};

export default EditRoadSectionWidthModal;
